import { create } from 'zustand';
import { CalendlyExpert } from '../../features/experts/types/CalendlyExpert';

export interface ExpertsState {
  nutritionist: CalendlyExpert | null;
  specialist: CalendlyExpert | null;
  admin: CalendlyExpert | null;
  physician: CalendlyExpert | null;
}

interface ExpertsStore {
  experts: ExpertsState;
  updateExperts: (updates: Partial<ExpertsState>) => void;
  clearExperts: () => void;
}

// Zustand store
export const useExpertsStore = create<ExpertsStore>((set) => ({
  // Initialize from localStorage
  experts: (JSON.parse(
    localStorage.getItem('experts') || '{}',
  ) as ExpertsState) || {
    nutritionist: null,
    specialist: null,
    admin: null,
    physician: null,
  },

  updateExperts: (updates) => {
    set((state) => {
      const newExperts = { ...state.experts, ...updates };
      localStorage.setItem('experts', JSON.stringify(newExperts));
      return { experts: newExperts };
    });
  },

  clearExperts: () => {
    set({ experts: { nutritionist: null, specialist: null, admin: null, physician: null } });
    localStorage.removeItem('experts');
  },
}));
